import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import classNames from 'classnames'
import { getPlanName } from 'helpers'
import removeIcon from '@assets/images/v2-dashboard/remove.svg'
import './index.css'

const ModalSubscriptionSuccess = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()

  const { visibleModalID } = settings
  const modalID = 'subscriptionSuccess'
  const visible = modalID === visibleModalID

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  return (
    <div>
      {!settings.isMobileXSView ? (
        <Modal
          className="custom__success__modal"
          title={<div>Congratulations!</div>}
          open={visible}
          onCancel={handleCancel}
          footer={false}
          maskClosable={false}
        >
          <div className="p-0">
            <div className="">
              Your plan has been updated to {getPlanName(apps.active)} for your app{' '}
              {apps.active.name} with app ID {apps.active.id}.
            </div>
          </div>
        </Modal>
      ) : (
        <SlidingPane
          isOpen={visible}
          onRequestClose={handleCancel}
          className={classNames('custom__extension__slider', 'successSubcription')}
          width="100%"
          from="bottom"
          title={<div>Congratulations!</div>}
          closeIcon={
            <img
              src={removeIcon}
              className="closeSuccessSub"
              alt="close"
            />
          }
        >
          <div className="p-0">
            <div className="">
              Your plan has been updated to {getPlanName(apps.active)} for your app{' '}
              {apps.active.name} with app ID {apps.active.id}.
            </div>
          </div>
        </SlidingPane>
      )}
    </div>
  )
}

export default ModalSubscriptionSuccess
